import React, { FC } from 'react';
import profilePic from '../../images/ProfilePic.svg'

interface ImageButtonProps {
    image: string | undefined;
    onClick: () => void;
    selected?: boolean;
}

const ImageButton: FC<ImageButtonProps> = ({ image = null, onClick, selected = false }) => {
    const borderStyle = selected ? 'border-portal-blue-primary' : 'border-gray-400';
    return (
        <div className="flex flex-row justify-center m-1 ">
            <button type="button" className={`h-12 w-12 overflow-hidden rounded-full border-2 ${borderStyle} text-gray-400 text-2xl`} onClick={onClick}>
                {image
                    ? <img className="rounded-full w-full h-full object-contain" src={`data:image/png;base64,${image}`} alt="user" />
                    : <img className="mt-px" src={profilePic} alt="" />
                }
            </button>
        </div>
    );
}

export default ImageButton;
